export const PLAYER_SCROLL_DURATION_MS = 950;
export const PLAYER_SCROLL_OFFSET_ROWS = 4;
export const PLAYER_SCROLL_TARGET_ROW = 3;
export const PLAYER_SCROLL_STICKY_HEADER_PX = 35;

const findScrollableParent = (element) => {
  let node = element?.parentElement || null;

  while (node && node !== document.body) {
    const style = window.getComputedStyle(node);
    const canScroll = /(auto|scroll)/.test(style.overflowY);

    if (canScroll && node.scrollHeight > node.clientHeight) {
      return node;
    }

    node = node.parentElement;
  }

  return document.scrollingElement || document.documentElement;
};

export const smoothScrollRowIntoView = (
  row,
  {
    container = null,
    duration = PLAYER_SCROLL_DURATION_MS,
    offsetRows = PLAYER_SCROLL_OFFSET_ROWS,
    targetRow = null,
    stickyHeaderHeight = 0,
  } = {}
) => {
  const scrollContainer = container || findScrollableParent(row);
  if (!row || !scrollContainer) return null;

  const startTop = scrollContainer.scrollTop;
  const containerRect = scrollContainer.getBoundingClientRect();
  const rowRect = row.getBoundingClientRect();
  const rowOffset = row.offsetHeight * offsetRows;
  const rowTopInContainer = rowRect.top - containerRect.top + scrollContainer.scrollTop;
  const targetRowTop =
    Number.isFinite(targetRow) && targetRow > 0
      ? rowTopInContainer - stickyHeaderHeight - row.offsetHeight * (targetRow - 1)
      : rowTopInContainer - (scrollContainer.clientHeight - row.offsetHeight) / 2 + rowOffset;
  const targetTop = Math.max(
    0,
    Math.min(
      targetRowTop,
      scrollContainer.scrollHeight - scrollContainer.clientHeight
    )
  );
  const delta = targetTop - startTop;
  const startTime = performance.now();

  const easeInOutCubic = (t) =>
    t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

  let frameId = null;
  const step = (now) => {
    const progress = Math.min((now - startTime) / duration, 1);
    scrollContainer.scrollTop = startTop + delta * easeInOutCubic(progress);

    if (progress < 1) {
      frameId = requestAnimationFrame(step);
    }
  };

  frameId = requestAnimationFrame(step);
  return () => {
    if (frameId) cancelAnimationFrame(frameId);
  };
};
